var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',{staticClass:"align-items-center",attrs:{"horizontal":""}},[_c('b-list-group-item',[_c('b',[_vm._v(_vm._s(_vm.label))])]),_c('b-list-group-item',{staticClass:"ml-2"},[_c('b-form-select',{attrs:{"size":"sm","options":_vm.options},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }